import { render, staticRenderFns } from "./funding-provisions-header.vue?vue&type=template&id=1538d2d6&scoped=true"
import script from "./funding-provisions-header.vue?vue&type=script&lang=js"
export * from "./funding-provisions-header.vue?vue&type=script&lang=js"
import style0 from "./funding-provisions-header.vue?vue&type=style&index=0&id=1538d2d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1538d2d6",
  null
  
)

export default component.exports